// @ actions
const notification = require('actions/notifications');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('../loansConstants/actionTypes');
const { FILTERS_VALID, FILTERS_INVALID, REQUESTED_LIST_PLANS } = require('constants/index');

const setLoanAliasRequest = (loanId, alias) => ({
    type: actionTypes.SET_LOAN_ALIAS_REQUEST,
    payload: {
        loanId,
        alias
    }
});

const setAccountAliasSuccess = (loanId, alias) => ({
    type: actionTypes.SET_LOAN_ALIAS_SUCCESS,
    payload: {
        loanId,
        alias
    }
});

const setAccountAliasFailure = (loanId) => ({
    type: actionTypes.SET_LOAN_ALIAS_FAILURE,
    payload: {
        loanId
    }
});

const setLoanAlias = (loanId, alias, isMortgage) => (dispatch, getState) => {
    const loan = getState().loans.get('byId').get(loanId);
    const validFilter = loan.get('filters').get('valid') ? FILTERS_VALID : FILTERS_INVALID;
    const loanRequestData = {
        query: {
            listaPrestamos: {
                prestamos: [
                    {
                        cnuevo: {
                            numerodecontrato: loan.get('newContractNumber'),
                            producto: loan.get('newProduct')
                        },
                        descripcion: loan.get('alias'),
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: validFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_PLANS
        }
    };
    dispatch(setLoanAliasRequest(loanId, alias));
    return APIPost({
        dispatch,
        endpoint: 'setCustomProfileEditSettings',
        url: apiURLBuilder.getURL('setCustomProfileEditSettings'),
        params: loanRequestData
    })
        .then(() => {
            let message = formatText('loan-editAliasSuccess');
            if (isMortgage) {
                message = formatText('loan-loan_editMortgageAliasSuccess');
            }
            dispatch(notification.success({ message }, { voice: message }));
            dispatch(setAccountAliasSuccess(loanId, alias))
        })
        .catch(() => {
            let message = formatText('loan-editAliasError');
            if (isMortgage) {
                message = formatText('loan-loan_editMortgageAliasError');
            }
            dispatch(notification.error({ message }, { voice: message }));
            dispatch(setAccountAliasFailure(loanId))
        })
};

module.exports = {
    setLoanAlias
};
